var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 217 217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0051a0;stroke:#057be9;stroke-miterlimit:10;stroke-width:7px;}.cls-2{fill:#036cd0;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon Rms") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.5,
    y: 3.5,
    width: 210,
    height: 210,
    rx: 23.6
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.54 187.3 200.39 36.56 80.84 53.27 159.92 69.98 111.54 187.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "148.41 78.14 104.23 187.3 16.61 38.79 94.21 136.8 148.41 78.14"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "94.21 124.18 19.21 28.77 192.96 28.77 68.96 46.59 94.21 124.18"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "83.69 61.75 99.28 120.41 141.85 76.47 83.69 61.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.27,153.45,39.37,179H19.25l15.5-66.44H66.17c15.61,0,23.76,7,23.76,17.45,0,9-6,15.15-15.05,17.51,3.92,1.56,8.65,5.59,6.17,16.41-1.61,6.93-2.78,12.19-2.44,15.07H59.28c-.43-2.86.14-7.55,2-15.68,1.48-6.28.79-9.87-6.46-9.87Zm3-12.92h9.32c7,0,11.81-2.51,11.81-8.46,0-4-2.31-6.59-8.56-6.59H51.78Z",
    transform: "translate(-1.23 -1.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.15,163.69c1.69-7.34,4.12-17.1,5.6-22.68h-.33C136,151.08,129.56,165.29,123,179H111.28c.16-12.28,0-27.54.54-38h-.43c-.88,5.52-2.82,15-4.69,23L103.22,179H90.3l11-46.94h20.9c.08,8.92-.23,23.14-.65,30h.26c3.08-7.68,8.81-19.21,14-30H156.4l-11,46.94H131.6Z",
    transform: "translate(-1.23 -1.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.35,164.32c.35,3.79,3,6.41,8.32,6.41,4.27,0,6.86-1.35,6.86-4.73,0-3-2.37-4.53-8.47-6.34-11-3.27-15.41-7.15-15.41-13.41,0-8.54,6.9-15.06,20.79-15.06,12.6,0,20.39,5.3,20.57,14.42H187.94c-.1-2.15-1.12-5.21-6.74-5.21-3.4,0-5.88,1.31-5.88,4.16,0,2.22,1.88,3.62,7.94,5.4,11.53,3.39,16.34,7.57,16.34,14.46,0,8.93-7.19,15.46-22.76,15.46-14.23,0-21.28-6.08-21.58-15.56Z",
    transform: "translate(-1.23 -1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRms);
export default __webpack_public_path__ + "static/media/icon-RMS.2b2ce038d328a024a424e2dd2bab54d5.svg";
export { ForwardRef as ReactComponent };